import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService, ConfirmationService } from 'primeng/api';
import { HttpErrorResponse } from '@angular/common/http';
import { MedicoService } from 'src/app/services/medico.service';
import { Medico } from 'src/app/models/medico.interface';
import { AuthService } from 'src/app/services/auth.service';
import { CasoClinico, CasoClinicoFormatoXLS } from 'src/app/models/caso-clinico.interface';
@Component({
  selector: 'app-medico-casosclinicos',
  templateUrl: './medico-casosclinicos.component.html',
  styleUrls: ['./medico-casosclinicos.component.scss'],
  providers: [ConfirmationService]
})
export class MedicoCasosclinicosComponent {
  casosClinicos: CasoClinico[] = [];
  medico!: Medico;
  constructor(
    private medicoService: MedicoService,
    private authService: AuthService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private router: Router) {
    if (this.authService.getLoggedIn) {
      const id: number | undefined = this.authService.getUsuario?.medico?.id;
      if (id) this.obtenerInformacion(id);
    }
  }

  obtenerInformacion(id: number): void {

    this.medicoService.getMedicos(id).subscribe({
      next: (resp) => {
        this.casosClinicos = resp.datos.casosclinicos;
        this.medico = resp.datos;
      },
      error: (err) => console.log(err)
    });

  }

  nuevoCasoClinico(): void {
    void this.router.navigate(['/medico/casoclinico', '0']);
  }

  deleteCasoClinico(id: number): void {
    this.confirmationService.confirm({
      message: 'Estas seguro de eliminar el caso clinico?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.medicoService
          .eliminarCasoClinico(id)
          .subscribe({
            next: (resp) => {
              this.showSuccess(resp.mensaje);
              this.casosClinicos = this.casosClinicos.filter((item) => item.id !== id);
            },
            error: (err: HttpErrorResponse) => {
              console.log(err.message)
            }
          })

      }
    });
  }

  showSuccess(mensaje: string): void {
    this.messageService.add({
      severity: 'success',
      summary: 'Éxito',
      detail: mensaje
    });
  }

  showError(mensaje: string): void {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: mensaje
    });
  }

  exportExcel(): void {
    console.log(this.medico);
    const EXCEL_EXTENSION = '.xlsx';
    const casosClinicos: CasoClinicoFormatoXLS[] = this.fullCasosClinicosXLSX(this.medico.casosclinicos);
    const nombreMedico = [{ campo: "Medico", nomMedico: this.medico.nom_medico }];
    const fileName = 'medico-casosclinicos';

    import('xlsx').then((XLSX) => {
      const ws = XLSX.utils.json_to_sheet([]);
      XLSX.utils.sheet_add_json(ws, nombreMedico, { origin: "A2", skipHeader: true });
      XLSX.utils.sheet_add_json(ws, casosClinicos, { origin: "A4" });
      /* generate workbook and add the worksheet */
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'casos_clinicos');
      /* save to file */

      XLSX.writeFile(wb, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    });
  }

  fullCasosClinicosXLSX(casoclinico: CasoClinico[]): CasoClinicoFormatoXLS[] {
    const casosclinicosxlsx: CasoClinicoFormatoXLS[] = casoclinico.map((item) => {
      return <CasoClinicoFormatoXLS>{
        fecha: item.fecha,
        folio: item.folio,
        serie: item.serie,
        paciente: item.paciente,
        sexo: item.sexo,
        edad: item.edad,
        antecedente: item.antecedente,
        institucion: item.cveInstitucion,
        hospital: item.nomHospital,
        fechaAplicacionProducto: item.fechaAplicacionProducto,
        diagnostico: item.diagnostico,
        antibiotico1: item.nomAntibiotico1,
        cantidad1: item.cantidad1,
        antibiotico2: item.nomAntibiotico2,
        cantidad2: item.cantidad2,
        antibiotico3: item.nomAntibiotico3,
        cantidad3: item.cantidad3,
        tratamiento: item.tratamiento,
        cuerpo: item.nomCuerpo,
        observacion: item.observacion,
        enfermera: item.enfermera.nom_enfermera,
        productos: item.productos.length,
        documentos: item.documentos.length
      }
    });
    return casosclinicosxlsx;
  }
}
